export const isMacOperatingSystem = window.navigator.platform.toUpperCase().indexOf('MAC') >= 0;
